import React from 'react';
import {Link} from 'react-router';
import {ChiTietDoiTuongThanhTraDialog} from 'modules/dialog';
import { msg } from "constants/message";
import {DeleteDialog} from 'modules/dialog';
import { connect } from 'react-redux';

class RowItemChiTietCuocThanhTra  extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      chiTietDT: false,
      loaiPopup: ''
    }
  }
  toggleDialog(name, status) {
    this.setState({[name]: status});
  }

  render() {
    let Data = this.props.item || {};
    let dataItemNamThanhTra = Data && Data.keHoachThanhTraGocInfo ? Data.keHoachThanhTraGocInfo.namThanhTra : null;
    let getTen = '';

    if (Data && Data.doiTuongThanhTras && Data.doiTuongThanhTras.length > 0 && Data.cuocThanhTraNhieuDoiTuong === false) {
      getTen = Data.doiTuongThanhTras[0].ten;
    } else if (Data && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0 && Data.cuocThanhTraNhieuDoiTuong === false) {
      getTen = Data.listDoiTuongThanhTra[0].ten;
    } else if (Data.tenNhieuDoiTuongThanhTra && Data.cuocThanhTraNhieuDoiTuong === true) {
      getTen = this.props.item.tenNhieuDoiTuongThanhTra;
    }
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
            <Link className="txt-underline txt-regular" name='abc' onClick={this.toggleDialog.bind(this, 'chiTietDT', true)}>{ getTen }</Link>
            <ChiTietDoiTuongThanhTraDialog name="chiTietDT" data={this.props.item} open={this.state.chiTietDT} onClose={this.toggleDialog.bind(this, 'chiTietDT', false)} />
        </td>
        <td>{this.props.item.noiDungThanhTra}</td>
        <td>
          <ul className="list-items-table">
            {
              this.props.item.chucNangCuocThanhTraInfo != null && this.props.item.chucNangCuocThanhTraInfo.type == 'CHUYEN_NGANH' ?
                <ul>
                  <li>{this.props.item.chucNangCuocThanhTraInfo.text + ' / '}{this.props.item.hinhThucThanhTraChuyenNganhInfo ? this.props.item.hinhThucThanhTraChuyenNganhInfo.text : ''}</li>
                </ul>
              :
                <li>
                  {
                    this.props.item.chucNangCuocThanhTraInfo != null && this.props.item.linhVucThanhTraInfo && this.props.item.linhVucThanhTraInfo.text &&
                      this.props.item.chucNangCuocThanhTraInfo.text+' / '+this.props.item.linhVucThanhTraInfo.text
                  }
                </li>
            }
          </ul>
          {
            this.props.item.chucNangCuocThanhTraInfo != null && this.props.item.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' && (this.props.item.linhVucThanhTraInfo == null || !this.props.item.linhVucThanhTraInfo.type) && this.props.isSubmit &&
              <div className="pt-form-helper-text">{msg.messageLinhVucTT}</div>
          }
          {
            this.props.item.chucNangCuocThanhTraInfo != null && this.props.item.chucNangCuocThanhTraInfo.type == 'CHUYEN_NGANH' && (this.props.item.hinhThucThanhTraChuyenNganhInfo == null || !this.props.item.hinhThucThanhTraChuyenNganhInfo.type) && this.props.isSubmit &&
              <div className="pt-form-helper-text">{msg.messageHinhThucTT}</div>
          }
        </td>
         <td>{this.props.item.thoiHanThanhTra}</td>
        <td>{this.props.item.kyThanhTra}</td>
        <td>{this.props.item.thoiGianTienHanh}</td>
        {/* <td>{this.props.item.donViChuTriInfo ? this.props.item.donViChuTriInfo.ten : '' }
            {
              !this.props.item.donViChuTriInfo.coQuanQuanLyId && this.props.isSubmit ?
                <div className="pt-form-helper-text">{msg.messageDefault}</div>
              :''
            }
        </td> */}
        {/* <td>{ this.props.item.donViPhoiHop ?  this.props.item.donViPhoiHop : '' }</td> */}
      </tr>
    );
  }
}

export default RowItemChiTietCuocThanhTra;



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemChiTietCuocThanhTra.jsx